import styled from 'styled-components';

export const TilesWrapper = styled.div`
width:100%;
height:auto;
display:grid;
place-items:center;

.wrapper-class,.rdw-option-wrapper{
    border: 1px solid #ced4da !important;
}
.rdw-editor-toolbar {
    border-bottom: 1px solid #ced4da !important;
}
.overflow-x-scroll{
  overflow-x:scroll !important;
}
.overflow-x-visible{
    overflow-x:visible !important;
  }
.tiles-preview{
    display:grid;
    grid-template-columns:repeat(5,50px);
    grid-template-rows:repeat(2,50px);
    border:2px solid #f1f1f1;
    background:#f1f1f1;
    gap:5px;
}
// .active-tile{
//     border:2px solid #2cd071;
// }
.bg-blue{
    background-color:dodgerblue;
}
#shape-tiles .tiles-container{
    display:grid;
    grid-template-columns:repeat(7,50px);
    grid-template-rows:repeat(7,50px);
    gap:2px;
    border:2px solid #f1f1f1;
    background:#f1f1f1;
}
#tile-preview .tiles-container{
    display:grid;
    gap:2px;
    border:2px solid #f1f1f1;
    background:#f1f1f1;
}
#tile-preview{
    .blue-tile-top{
        width: 100%;
        height: 100%;
        border-top: 0px solid transparent;
        border-left: 15px solid dodgerblue;
        border-bottom: 15px solid transparent;
    }
    .blue-tile-right{
        width: 100%;
        height: 100%;
        border-top: 0px solid transparent;
        border-right: 15px solid dodgerblue;
        border-bottom: 15px solid transparent;
    }
    
    .blue-tile-bottom{
        width: 100%;
        height: 100%;
        border-top: 15px solid transparent;
        border-right: 15px solid dodgerblue;
        border-bottom: 0px solid transparent;
    }
    .blue-tile-left{
        width: 100%;
        height: 100%;
        border-top: 15px solid transparent;
        border-left: 15px solid dodgerblue;
        border-bottom: 0px solid transparent;
    }
    .v-white-tile-top{
            width: 100%;
            height: 100%;
            border-left: 8px solid transparent;
            border-right: 8px solid transparent;
            border-top: 8px solid #fff;
        }
        .v-white-tile-right{
            width: 100%;
            height: 100%;
            border-top: 8px solid transparent;
            border-right: 8px solid #fff;
            border-bottom: 8px solid transparent;
        }
        
        .v-white-tile-bottom{
            width: 100%;
            height: 100%;
            border-left: 8px solid transparent;
            border-right: 8px solid transparent;
            border-bottom: 8px solid #fff;
        }
        
        .v-white-tile-left{
            width: 100%;
            height: 100%;
            border-top: 8px solid transparent;
            border-left: 8px solid #fff;
            border-bottom: 8px solid transparent;
        }
}

#word-tiles{
    border:2px solid #f1f1f1;
    border:none;
    align-items:center;
}
#word-tiles .tiles-container{
    display:grid;
    grid-template-columns:repeat(5,15px);
    grid-template-rows:repeat(7,15px);
    gap:2px;
    background:#f1f1f1;
    border:1px solid #f1f1f1;
}
.two-tiles-container{
    display:grid;
    grid-template-columns:repeat(2,15px);
    grid-template-rows:repeat(7,15px);
    gap:2px;
    background:#f1f1f1;
    border:1px solid #f1f1f1;

}
.three-tiles-container{
    display:grid;
    grid-template-columns:repeat(3,15px);
    grid-template-rows:repeat(7,15px);
    gap:2px;
    background:#f1f1f1;
    border:1px solid #f1f1f1;

}
.four-tiles-container{
    display:grid;
    grid-template-columns:repeat(4,15px);
    grid-template-rows:repeat(7,15px);
    gap:2px;
    background:#f1f1f1;
    border:1px solid #f1f1f1;

}
.five-tiles-container{
    display:grid;
    grid-template-columns:repeat(5,15px);
    grid-template-rows:repeat(7,15px);
    gap:2px;
    background:#f1f1f1;
    border:1px solid #f1f1f1;

}
.six-tiles-container{
    display:grid;
    grid-template-columns:repeat(6,15px);
    grid-template-rows:repeat(7,15px);
    gap:2px;
    background:#f1f1f1;
    border:1px solid #f1f1f1;

}
.seven-tiles-container{
    display:grid;
    grid-template-columns:repeat(7,15px);
    grid-template-rows:repeat(7,15px);
    gap:2px;
    background:#f1f1f1;
    border:1px solid #f1f1f1;

}
.eight-tiles-container{
    display:grid;
    grid-template-columns:repeat(8,15px);
    grid-template-rows:repeat(7,15px);
    gap:2px;
    background:#f1f1f1;
    border:1px solid #f1f1f1;


}

.end-tiles-container{
    display: grid;
    grid-template-columns: repeat(1,15px);
    grid-template-rows: repeat(7,15px);
    gap: 2px;
    border:1px solid #f1f1f1;
    float: left;
    background: #f1f1f1;

}
.end-tiles-container1{
    display:grid;
    grid-template-columns:repeat(1,15px);
    grid-template-rows:repeat(7,15px);
    gap:2px;
    background:#f1f1f1;
    border:1px solid #f1f1f1;


}
#word-tiles{
    .blue-tile-top{
        width: 100%;
        height: 100%;
        border-top: 0px solid transparent;
        border-left: 15px solid dodgerblue;
        border-bottom: 15px solid transparent;
    }
    .blue-tile-right{
        width: 100%;
        height: 100%;
        border-top: 0px solid transparent;
        border-right: 15px solid dodgerblue;
        border-bottom: 15px solid transparent;
    }
    
    .blue-tile-bottom{
        width: 100%;
        height: 100%;
        border-top: 15px solid transparent;
        border-right: 15px solid dodgerblue;
        border-bottom: 0px solid transparent;
    }
    .blue-tile-left{
        width: 100%;
        height: 100%;
        border-top: 15px solid transparent;
        border-left: 15px solid dodgerblue;
        border-bottom: 0px solid transparent;
    }
    .v-white-tile-top{
            width: 100%;
            height: 100%;
            border-left: 8px solid transparent;
            border-right: 8px solid transparent;
            border-top: 8px solid #fff;
        }
        .v-white-tile-right{
            width: 100%;
            height: 100%;
            border-top: 8px solid transparent;
            border-right: 8px solid #fff;
            border-bottom: 8px solid transparent;
        }
        
        .v-white-tile-bottom{
            width: 100%;
            height: 100%;
            border-left: 8px solid transparent;
            border-right: 8px solid transparent;
            border-bottom: 8px solid #fff;
        }
        
        .v-white-tile-left{
            width: 100%;
            height: 100%;
            border-top: 8px solid transparent;
            border-left: 8px solid #fff;
            border-bottom: 8px solid transparent;
        }
}
.tile{
    overflow:hidden;
    position:relative;
    cursor:pointer;
}
.white-tile{
    width:100%;
    height:100%;
    background-color:#fff;
}
.blue-tile{
    width:100%;
    height:100%;
    background:dodgerblue;
}
.blue-tile-top{
    width: 100%;
    height: 100%;
    border-top: 0px solid transparent;
    border-left: 50px solid dodgerblue;
    border-bottom: 50px solid transparent;
}
.blue-tile-right{
    width: 100%;
    height: 100%;
    border-top: 0px solid transparent;
    border-right: 55px solid dodgerblue;
    border-bottom: 55px solid transparent;
}

.blue-tile-bottom{
    width: 100%;
    height: 100%;
    border-top: 50px solid transparent;
    border-right: 50px solid dodgerblue;
    border-bottom: 0px solid transparent;
}
.blue-tile-left{
    width: 100%;
    height: 100%;
    border-top: 50px solid transparent;
    border-left: 50px solid dodgerblue;
    border-bottom: 0px solid transparent;
}
.v-white-tile-top{
    width: 100%;
    height: 100%;
    border-left: 25px solid transparent;
	border-right: 25px solid transparent;
	border-top: 25px solid #fff;
}
.v-white-tile-right{
    width: 100%;
	height: 100%;
	border-top: 25px solid transparent;
	border-right: 25px solid #fff;
	border-bottom: 25px solid transparent;
}

.v-white-tile-bottom{
    width: 100%;
	height: 100%;
	border-left: 25px solid transparent;
	border-right: 25px solid transparent;
	border-bottom: 25px solid #fff;
}

.v-white-tile-left{
    width: 100%;
	height: 100%;
	border-top: 25px solid transparent;
	border-left: 25px solid #fff;
	border-bottom: 25px solid transparent;
}
@media (max-width:600px){
    .tiles-preview{
        display:grid;
        max-width:200px;
        grid-template-columns:repeat(5,35px);
        grid-template-rows:repeat(1,35px);
        border:2px solid #f1f1f1;
        background:#f1f1f1;
        gap:5px;
    }

    #shape-tiles .tiles-container{
        grid-template-columns:repeat(7,35px);
        grid-template-rows:repeat(7,35px);
    }
   
    .blue-tile-top{
        width: 100%;
        height: 100%;
        border-top: 0px solid transparent;
        border-left: 35px solid dodgerblue;
        border-bottom: 35px solid transparent;
    }
    .blue-tile-right{
        width: 100%;
        height: 100%;
        border-top: 0px solid transparent;
        border-right: 35px solid dodgerblue;
        border-bottom: 35px solid transparent;
    }
    
    .blue-tile-bottom{
        width: 100%;
        height: 100%;
        border-top: 35px solid transparent;
        border-right: 35px solid dodgerblue;
        border-bottom: 0px solid transparent;
    }
    .blue-tile-left{
        width: 100%;
        height: 100%;
        border-top: 35px solid transparent;
        border-left: 35px solid dodgerblue;
        border-bottom: 0px solid transparent;
    }
    .v-white-tile-top{
            width: 100%;
            height: 100%;
            border-left: 171px solid transparent;
            border-right: 171px solid transparent;
            border-top: 171px solid #fff;
        }
        .v-white-tile-right{
            width: 100%;
            height: 100%;
            border-top: 171px solid transparent;
            border-right: 171px solid #fff;
            border-bottom: 171px solid transparent;
        }
        
        .v-white-tile-bottom{
            width: 100%;
            height: 100%;
            border-left: 171px solid transparent;
            border-right: 171px solid transparent;
            border-bottom: 171px solid #fff;
        }
        
        .v-white-tile-left{
            width: 100%;
            height: 100%;
            border-top: 171px solid transparent;
            border-left: 171px solid #fff;
            border-bottom: 171px solid transparent;
        }


        #word-tiles{
            .blue-tile-top{
                width: 100%;
                height: 100%;
                border-top: 0px solid transparent;
                border-left: 6px solid dodgerblue;
                border-bottom: 6px solid transparent;
            }
            .blue-tile-right{
                width: 100%;
                height: 100%;
                border-top: 0px solid transparent;
                border-right: 6px solid dodgerblue;
                border-bottom: 6px solid transparent;
            }
            
            .blue-tile-bottom{
                width: 100%;
                height: 100%;
                border-top: 6px solid transparent;
                border-right: 6px solid dodgerblue;
                border-bottom: 0px solid transparent;
            }
            .blue-tile-left{
                width: 100%;
                height: 100%;
                border-top: 6px solid transparent;
                border-left: 6px solid dodgerblue;
                border-bottom: 0px solid transparent;
            }
            .v-white-tile-top{
                    width: 100%;
                    height: 100%;
                    border-left: 2px solid transparent;
                    border-right: 2px solid transparent;
                    border-top: 2px solid #fff;
                }
                .v-white-tile-right{
                    width: 100%;
                    height: 100%;
                    border-top: 2px solid transparent;
                    border-right: 2px solid #fff;
                    border-bottom: 2px solid transparent;
                }
                
                .v-white-tile-bottom{
                    width: 100%;
                    height: 100%;
                    border-left: 2px solid transparent;
                    border-right: 2px solid transparent;
                    border-bottom: 2px solid #fff;
                }
                
                .v-white-tile-left{
                    width: 100%;
                    height: 100%;
                    border-top: 2px solid transparent;
                    border-left: 2px solid #fff;
                    border-bottom: 2px solid transparent;
                }
        }
        #word-tiles .tiles-container{
            grid-template-columns:repeat(5,6px);
            grid-template-rows:repeat(7,6px);
            gap:1px;
            border:.3px solid #f1f1f1;
           
        }
        .two-tiles-container{
            grid-template-columns:repeat(2,6px);
            grid-template-rows:repeat(7,6px);
            gap:1px;
            border:.3px solid #f1f1f1;
        }
        .three-tiles-container{
            grid-template-columns:repeat(3,6px);
            grid-template-rows:repeat(7,6px);
            gap:1px;
            border:.3px solid #f1f1f1;
        }
        .four-tiles-container{
            grid-template-columns:repeat(4,6px);
            grid-template-rows:repeat(7,6px);
            gap:1px;
            border:.3px solid #f1f1f1;
        }
        .five-tiles-container{
            grid-template-columns:repeat(5,6px);
            grid-template-rows:repeat(7,6px);
            gap:1px;
            border:.3px solid #f1f1f1;
        }
        .six-tiles-container{
            grid-template-columns:repeat(6,6px);
            grid-template-rows:repeat(7,6px);
            gap:1px;
            border:.3px solid #f1f1f1;
        }
        .seven-tiles-container{
            grid-template-columns:repeat(7,6px);
            grid-template-rows:repeat(7,6px);
            gap:1px;
            border:.3px solid #f1f1f1;
        }
        .eight-tiles-container{
            grid-template-columns:repeat(8,6px);
            grid-template-rows:repeat(7,6px);
            gap:1px;
            border:.3px solid #f1f1f1;
        }
        
        .end-tiles-container{
            grid-template-columns: repeat(1,6px);
            grid-template-rows: repeat(7,6px);
            gap:1px;
            border:.3px solid #f1f1f1;
        }
        .end-tiles-container1{
            grid-template-columns:repeat(1,6px);
            grid-template-rows:repeat(7,6px);
            gap:1px;
            border:.3px solid #f1f1f1;
        }
}
.border-none{
    border:none !important;
}
.wrapper-class{
    border: 1px solid #ced4da;
}
.rdw-editor-toolbar{
   background: #F1F1F1;
   border:none;
   border-bottom: 1px solid #ced4da;
}
.editor-class{
    padding:0 10px;
}
.float-left{
    float:left;
}
.clear-left{
    clear:left;
}
.border-primary{
    border:1px solid #1478dd;
}
`;